import { economicCodes } from "../economicCodes";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const economicCode = [
  {
    label: `All (Only for report download)`,
    value: "ALL",
  },
  ...economicCodes.map((e) => ({
    label: `${e.ECON_CODE}-${e.ECON_NAME_BN}-${e.ECON_NAME_EN}`,
    value: e.ECON_CODE,
  })),
];

export const searchFields = [
  {
    value: "economicCode",
    label: "Economic Code",
  },
  {
    value: "mobile",
    label: "Mobile Number",
  },
  {
    value: "acsRef",
    label: "ACS Reference",
  },
  {
    value: "bkashTrxId",
    label: "bKash Transaction ID",
  },
];

export const defaultTransParamValue = {
  economicCode: "1131101",
  mobile: "",
  acsRef: "",
  bkashTrxId: "",
  endTimestamp: new Date().valueOf(),
  startTimestamp: (() => {
    let d = new Date();
    d.setMonth(d.getMonth() - 1);
    return d.valueOf();
  })(),
};

export const statusCode = [
  {
    label: "Pymnt. Created",
    value: "PAYMENT_CREATED",
  },
  {
    label: "Pymnt. Executed",
    value: "PAYMENT_EXECUTED",
  },
  {
    label: "Trnx. Created",
    value: "TRANSACTION_CREATED",
  },
  {
    label: "Verified By ACS",
    value: "VERIFIED_BY_ACS",
  },
  // {
  //   label: "Refunded",
  //   value: "PAYMENT_REFUNDED",
  // },
  {
    label: "Failed",
    value: "PAYMENT_FAILED",
  },
  {
    label: "Cancelled",
    value: "PAYMENT_CANCELLED",
  },
  // {
  //   label: "Requested",
  //   value: "REFUND_REQUESTED",
  // },
  {
    label: "All",
    value: "all",
  },
];

const map = {
  PAYMENT_CREATED: {
    label: "Pymnt. Created",
    bg: "rgba(226, 19, 110, 0.04)",
    color: "rgba(226, 19, 110, 1)",
  },
  PAYMENT_EXECUTED: {
    label: "Pymnt. Executed",
    bg: "rgba(98, 54, 255, 0.04)",
    color: "rgba(98, 54, 255, 1)",
  },
  TRANSACTION_CREATED: {
    label: "Trnx. Created",
    bg: "rgba(54, 43, 115, 0.04)",
    color: "rgba(54, 43, 115, 1)",
  },
  VERIFIED_BY_ACS: {
    label: "Verified By ACS",
    bg: "rgba(0, 177, 54, 0.04)",
    color: "rgba(0, 177, 54, 1)",
  },
  PAYMENT_REFUNDED: {
    label: "Refund",
    bg: "rgba(255, 0, 0, 0.04)",
    color: "rgba(255, 0, 0, 1)",
  },
  PAYMENT_FAILED: {
    label: "Failed",
    bg: "rgba(255, 0, 0, 0.04)",
    color: "rgba(255, 0, 0, 1)",
  },
  PAYMENT_CANCELLED: {
    label: "Cancelled",
    bg: "rgba(54, 43, 115, 0.04)",
    color: "rgba(54, 43, 115, 1)",
  },
  REFUND_REQUESTED: {
    label: "Requested",
    bg: "rgba(0, 177, 54, 0.04)",
    color: "rgba(0, 177, 54, 1)",
  },
};

const statusColorDecider = (value) => {
  return map[value] ? map[value].color : "";
};

export const dateMonthYearFormatter = (value) => {
  if (value == null) return "";

  const date = new Date(value);

  return `${date.getDate()} ${months[date.getMonth()].substring(
    0,
    3
  )} ${date.getFullYear()}`;
};

export const columnConfig = [
  {
    key: "createdAt",
    label: "Date",
    align: "left",
    formatFunction: (value) => {
      const date = new Date(value);

      return `${date.getDate()} ${months[date.getMonth()].substring(
        0,
        3
      )} ${date.getFullYear()}`;
    },
    subKey: "createdAt",
    subLabel: "Time",
    formatFunctionSubLevel: (value) => {
      const date = new Date(value);

      return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      });
    },
  },
  {
    key: "bkashWalletNumber",
    label: "bKash Wallet Number",
    align: "right",
    formatFunction: (value, status) => {
      return <span style={{ color: statusColorDecider(status) }}>{value}</span>;
    },
    subKey: "name",
    subLabel: "Name",
  },
  {
    key: "bkashPaymentId",
    label: "bKash Payment ID",
    subKey: "economicCode",
    subLabel: "Economic Code",
    align: "right",
  },
  { key: "bkashTrxid", label: "bKash Transaction ID", align: "right" },
  { key: "acsRef", label: "ACS Reference", align: "right" },
  { key: "mobile", label: "Mobile Number", align: "right" },
  {
    key: "state",
    label: "Status",
    align: "center",
    formatFunction: (value, status) => {
      return (
        <div
          style={{
            color: map[value]?.color,
            backgroundColor: map[value]?.bg,
            padding: 4,
            textAlign: "center",
            borderRadius: 16,
            fontSize: 12,
            fontWeight: 500,
          }}
        >
          {map[value] ? map[value].label : value}
        </div>
      );
    },
  },
  {
    key: "paidAmount",
    label: "Paid Amount",
    subKey: "bkashFee",
    subLabel: "bKash Fee",
    align: "right",
  },
];

export const analyticsBeltMetadata = (info) => {
  const data = info.reduce(
    (prev, element) => {
      return Object.entries(prev).reduce((obj, [key, value]) => {
        obj[key] = parseFloat(element[key]) + value;
        return obj;
      }, {});
    },
    {
      verifiedCount: 0,
      successCount: 0,
      totalChallanAmount: 0,
      totalFeeAmount: 0,
    }
  );

  return [
    {
      label: "Total Challan Collected (BDT)",
      value: data.totalChallanAmount.toLocaleString("en-US"),
    },
    {
      label: "Total Fee Collected (BDT)",
      value: data.totalFeeAmount.toLocaleString("en-US"),
    },
    {
      label: "ACS Verified Transactions",
      value: data.verifiedCount.toLocaleString("en-US"),
    },
    {
      label: "Successful Transactions",
      value: data.successCount.toLocaleString("en-US"),
    },
  ];
};
